import type { Task } from '../types/tasks';

/** The names a source system is shown under. An unlisted system shows as its own id. */
const SOURCE_NAMES: Record<string, string> = { 'temporary-permits': 'Temporary Permits' };

/**
 * A task mirrored from another system is that system's work: the server
 * refuses to edit, move, close or delete it, so the board must not offer to.
 */
export const isExternallyManaged = (task: Pick<Task, 'source'>): boolean => !!task.source;

/** "Temporary Permits", for a task managed there; null for an ordinary task. */
export const externalSourceName = (task: Pick<Task, 'source'>): string | null =>
  task.source ? (SOURCE_NAMES[task.source.system] ?? task.source.system) : null;
